import { TitleCasePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Patient } from 'src/app/core/api/patient.service';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { ConfirmModalService } from 'src/app/shared/confirm-modal/confirm-modal.service';
import { SearchablePatient } from '../intake-form-view/intake-form-view.component';

@Component({
  selector: 'csi-link-with-similar-patient-modal',
  templateUrl: './link-with-similar-patient-modal.component.html',
  styleUrls: ['./link-with-similar-patient-modal.component.css']
})
export class LinkWithSimilarPatientModalComponent implements OnInit {
  public displayColumns: string[];
  public columnNamesMap = {
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    gender: 'Gender',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    action: ''
  };

  public linkedPatientId = this.appStateService.getCurrentIntakeForm().intakeFormPatientId;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      patientList: SearchablePatient[];
      intakePatient: Partial<Patient>;
    },
    private router: Router,
    private appStateService: AppStateService,
    public dialogRef: MatDialogRef<LinkWithSimilarPatientModalComponent>,
    private confirmModalService: ConfirmModalService,
    private titleCasePipe: TitleCasePipe,
    private translocoService: TranslocoService
  ) {}

  ngOnInit() {
    this.displayColumns = Object.keys(this.columnNamesMap);
  }

  public static openLinkWithSimilarPatientModel(
    matDialog: MatDialog,
    patientList?: Partial<SearchablePatient>[],
    intakePatient?: Partial<Patient>
  ) {
    return matDialog.open(LinkWithSimilarPatientModalComponent, {
      width: '80vw',
      minWidth: '54rem',
      maxWidth: '95vw',
      data: { patientList, intakePatient }
    });
  }

  public navigateToPatient() {
    this.router.navigate([
      `/patients/${this.appStateService.getCurrentIntakeForm().intakeFormPatientId}`
    ]);
    this.dialogRef.close();
  }

  linkIntakeFormWithPatient(patientToLink: Patient) {
    const patientFullName = this.titleCasePipe.transform(
      patientToLink.firstName + ' ' + patientToLink.lastName
    );

    const linkTo = this.translocoService.translate('Link to');
    const aboutTo = this.translocoService.translate('You are about to link to');
    const doYouWish = this.translocoService.translate(
      'Do you wish to continue? Once linked, this action cannot be undone'
    );
    const confirmLink = this.translocoService.translate('Link and Confirm Patient information');

    this.confirmModalService
      .show(
        linkTo + ' ' + patientFullName,
        aboutTo + ' ' + patientFullName + '. ' + doYouWish + '.',
        confirmLink,
        this.translocoService.translate('Cancel')
      )
      .subscribe(linkConfirmed => {
        this.dialogRef.close(linkConfirmed ? patientToLink : null);
      });
  }
}
